<app-fiche-point [pointId]="pointId"></app-fiche-point>
